/* eslint-disable react/prop-types */
import * as React from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

interface Props {
  classes: {
    formGroup: string;
    children: string;
  };
  children?: React.ReactNode;
}

const styleSheet = () => ({
  formGroup: {
    alignItems: 'flex-end',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    margin: '0 auto',
    width: '100%',
    display: 'flex',
    flexFlow: 'row',
    marginTop: '20px',
    position: 'relative',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '@media (max-width: 900px)': {
      '& > div': {
        flex: '0 0 100% !important',
        padding: '0 !important',
      },
    },
  },
  children: {
    // "& > *:last-child": {
    //   marginLeft: 0,
    //   marginRight: 0
    // },
    // "& > *": {
    //   marginRight: "15px"
    // }
  },
});

const FormGroup: React.FC<Props> = ({ classes, children }) => {
  const childrenCount = React.Children.toArray(children).length;

  const groupClasses = classNames(classes.formGroup, {
    [classes.children]: childrenCount > 1,
  });

  return <div className={groupClasses}>{children}</div>;
};

export default injectSheet(styleSheet)(FormGroup);
